
export enum DB2DataSourceAvailability { AVAILABLE = 0, UNKNOWN = 1, UNAVAILABLE = 2 }

export class PrismDataSource {
    public LPAR: string;
    public DatabaseName: string;
    public ARDatabaseName: string;
    public ClientId4Digit: string;
    public ClientId3Digit: string;
    public Parent: string;
    public Description: string;
    public DataSourceStatus: number;
}



// WEBPACK FOOTER //
// ./src/app/models/prism-data-source.model.ts